import Vue from 'vue'
import environment from "@/assets/js/environment";
import Cookies from 'js-cookie'
import SocketIO from "socket.io-client"

const options = {
    // path: environment.socketOptions,
    transports: ['websocket'],
    // forceNew: true,
    timeout: 30000,
    forceNew: false,
    multiplex: false,
    closeOnBeforeunload: false,
    autoConnect: false,
    query: {
        'Authorization-Token': Cookies.get('DODO_TOKEN')
    }

}

export const rasaWs = SocketIO(environment.socketRasaUrl, options)

Vue.prototype.$rasaWs = rasaWs